export function isConditionalType(item) {
    return item.fieldName !== undefined;
}
export function isConditionalValidation(item) {
    return (item.conditions !== undefined ||
        item.logicalOperator !== undefined);
}
